import { root } from './Box.css';

import { RecipeVariants } from '@/style/utils/createRecipeObj';
import { createUseRecipeHook } from '@/style/utils/createUseRecipeHook';

export const useBoxStyle = createUseRecipeHook(root);
export type BoxStyleProps = RecipeVariants<typeof root>;
